/*
 * Middleware to store and refresh token
 */
import { CFPost } from "../util/api";
import { createStore } from "redux";
import { CFNavTo } from "../util/api";

const USER = "USER";
const ACCESS_TOKEN = "ACCESS_TOKEN";
const REFRESH_TOKEN = "REFRESH_TOKEN";

const RECEIVE_TOKENS = "RECEIVE_TOKENS";
const COMPELETED_TOKEN_REFRESH = "COMPELETED_TOKEN_REFRESH";
const REFRESHING_TOKEN = "REFRESHING_TOKEN";

const _initialState = {
    accessToken: getItem(ACCESS_TOKEN),
    refreshToken: getItem(REFRESH_TOKEN),
    refreshTokenPromise: null,
    isTokenRefreshing: false,
    isLoggedIn: isTokenSet(REFRESH_TOKEN),
    user: getUser()
};

export function authMiddleware({ dispatch }) {
    return next => action => {
        let { isTokenRefreshing, refreshTokenPromise } = tokenStore.getState();

        if (
            typeof action !== "function" &&
            (action.type && action.type !== "ATTEMPT_LOGIN") &&
            !action.fetchCall
        )
            return next(action);

        if (action.type === "ATTEMPT_LOGIN")
            return attemptLogin(action, dispatch);

        // if (isTokenRefreshing)
        //     return refreshTokenPromise.then(() => next(action));
        if (!isTokenRefreshing) {
            let { fetchCall, receivedAction, data } = action;
            authFetchRefreshWrapper(
                { fetchCall, receivedAction, data },
                dispatch
            ).then(() => next(action));
        }
    };
}
// used in agent portal
export function authMiddlewareV2({ dispatch }) {
    return next => action => {
        let { isTokenRefreshing } = tokenStore.getState();

        if (
            typeof action !== "function" &&
            (action.type && action.type !== "ATTEMPT_LOGIN") &&
            !action.fetchCall
        )
            return next(action);

        if (action.type === "ATTEMPT_LOGIN")
            return attemptLogin(action, dispatch);
        if (!isTokenRefreshing) {
            let { fetchCall, receivedAction, data } = action;
            authFetchRefreshWrapperV2(
                { fetchCall, receivedAction, data },
                dispatch
            ).then(() => next(action));
        }
    };
}

export function attemptLogin(action, dispatch) {
    let { body, loginApiAction, loginResponseAction } = action;
    return loginApiAction(body).then(response => {
        if (response.status !== resCodes.Unauthorized) {
            tokenStore.dispatch(
                receiveTokensAction({
                    refreshToken: response.refreshToken,
                    user: response.user
                })
            );
        }
        dispatch(loginResponseAction(response));
    });
}

function authFetchRefreshWrapper(
    { fetchCall, receivedAction, data },
    dispatch
) {
    let params = data.filters ? data.filters : data.body ? data.body : null;

    let { refreshTokenPromise, isTokenRefreshing } = tokenStore.getState();

    return fetchCall(params).then(response => {
        if (response.status === resCodes.Unauthorized) {
            // let promise = !isTokenRefreshing
            //                 ? dispatch(refreshTokenAction(data.locations))
            //                 : refreshTokenPromise;
            dispatch(refreshTokenAction(data.locations)).then(() => {
                return fetchCall(params).then(response => {
                    if (
                        response.status === resCodes.Unauthorized ||
                        response.status === resCodes.Forbidden
                    ) {
                        logout().then(() => {
                            console.log("TODO: Handle 401 followed by 401");
                            // CFNavTo({
                            //     url: data.locations.redirectUrl
                            // });
                        });
                    } else {
                        dispatch(receivedAction(response));
                    }
                });
            });
        } else if (response.status === resCodes.Forbidden) {
            console.log("TODO: Handle Forbidden");
            // CFNavTo({
            //     url: data.locations.forbiddenUrl
            // });

        } else {
            dispatch(receivedAction(response));
        }
    });
}
// used in agent portal
function authFetchRefreshWrapperV2(
    { fetchCall, receivedAction, data },
    dispatch
) {
    let params = data.filters ? data.filters : data.body ? data.body : null;

    return fetchCall(params).then(response => {
        if (response.status === resCodes.Unauthorized) {
            dispatch(refreshTokenAction(data.locations)).then(() => {
                return fetchCall(params).then(response => {
                    if (
                        response.status === resCodes.Unauthorized ||
                        response.status === resCodes.Forbidden
                    ) {
                        logout().then(() => {
                            console.log("TODO: Handle 401 followed by 401");
                        });
                    } else {
                        dispatch(receivedAction(response, data));
                    }
                });
            });
        } else if (response.status === resCodes.Forbidden) {
            console.log("TODO: Handle Forbidden");
        } else {
            dispatch(receivedAction(response, data));
        }
    });
}

export function refreshTokenAction(locations) {
    let { refreshToken } = tokenStore.getState();
    // let refreshTokenPromise =
    return function() {
        return fetchAccessToken(refreshToken, locations).then(response => {
            handleAccessTokenFetch(response, locations, refreshToken);
        });
    };
    // tokenStore.dispatch({
    //     type: REFRESHING_TOKEN,
    //     refreshTokenPromise: refreshTokenPromise
    // });
    // return refreshTokenPromise;
}

function fetchAccessToken(refreshToken, locations) {
    return CFPost({
        url: locations.tokenUrl,
        body: {
            RefreshToken: refreshToken
        },
        originURL: locations.originUrl,
        loaderName: "fetchAccessToken"
    });
}

function handleAccessTokenFetch(response, locations, refreshToken) {
    if (
        response.status === resCodes.Unauthorized ||
        response.status === resCodes.Redirect
    ) {
        logout().then(() => {
            CFNavTo({
                url: locations.redirectUrl
            });
        });
    } else {
        tokenStore.dispatch(
            receiveTokensAction({
                refreshToken: refreshToken,
                accessToken: response.authtoken
            })
        );
        tokenStore.dispatch({
            type: COMPELETED_TOKEN_REFRESH
        });
    }
}

function receiveTokensAction(response) {
    return {
        type: RECEIVE_TOKENS,
        accessToken: response.accessToken
            ? response.accessToken
            : getItem(ACCESS_TOKEN),
        refreshToken: response.refreshToken
            ? response.refreshToken
            : getItem(REFRESH_TOKEN),
        user: response.user ? response.user : getUser(),
        isLoggedIn: true
    };
}

function reducer(state = _init, action) {
    switch (action.type) {
        case COMPELETED_TOKEN_REFRESH:
            return {
                ...state,
                isTokenRefreshing: false
            };
        case REFRESHING_TOKEN:
            return {
                ...state,
                refreshTokenPromise: action.refreshTokenPromise,
                isTokenRefreshing: true
            };
        case RECEIVE_TOKENS:
            return {
                ...state,
                accessToken: action.accessToken,
                refreshToken: action.refreshToken,
                isLoggedIn: action.isLoggedIn,
                user: action.user
            };
        default:
            return state;
    }
}

export function getAccessTokenFromStore() {
    return tokenStore.getState().accessToken;
}

function isTokenSet(type) {

    let itemType =  typeof getItem(type) !== "undefined" && getItem(type) !== null && getItem(type) !== "" && getItem(type) !== "null"
    let userType =  typeof getItem(USER) !== "undefined" && getItem(USER) !== null && getItem(USER) !== "" && getItem(USER) !== "null"
    
    let result = itemType && userType;

    return result;
}

function getItem(type) {
    let item = "";
    try {
        item = localStorage.getItem(type);
    } catch (e) {
        console.log(e);
    }
    return item;
}
export function getUser() {
    let result = null;
    let user = getItem(USER);
    if(user !== undefined && user !== null && user !== "" && user !== "null") {
        try {
            result = JSON.parse(user);
        }
        catch(e) {
            console.log(e);
        }
    }
    return result;
}

function setTokens() {
    try {
        localStorage.setItem(ACCESS_TOKEN, tokenStore.getState().accessToken);
        localStorage.setItem(REFRESH_TOKEN, tokenStore.getState().refreshToken);
    } catch (e) {
        console.log(e);
    }
}

function setUser() {
    try {
        localStorage.setItem(
            USER,
            JSON.stringify(tokenStore.getState().user)
        );
    } catch (e) {
        console.log(e);
    }
}

function destroyUser() {
    try {
        delete localStorage[USER];
    } catch (e) {
        console.log(e);
    }
}

function destroyTokens() {
    try {
        delete localStorage[ACCESS_TOKEN];
        delete localStorage[REFRESH_TOKEN];
    } catch (e) {
        console.log(e);
    }
}

function resetAuthStateAction() {
    return {
        type: RECEIVE_TOKENS,
        accessToken: "",
        refreshToken: "",
        isLoggedIn: false
    };
}

export function logout() {
    return new Promise(resolve => {
        tokenStore.dispatch(resetAuthStateAction());
        destroyTokens();
        destroyUser();
        resolve();
    });
}

export function isLoggedIn() {
    return tokenStore.getState().isLoggedIn;
}

export let tokenStore = createStore(reducer, _initialState);
tokenStore.subscribe(() => {
    setTokens();
    setUser();
});

export let resCodes = {
    Unauthorized: 401,
    Forbidden: 403,
    Redirect: 302
};



// WEBPACK FOOTER //
// ./src/auth/token_actions.js